import React from "react";
import { Icon, IconButton } from "../../../atoms";
import { useDropzoneContext } from "../Dropzone";
import { DropzoneClearProps } from "../Dropzone.types";

const DropzoneClear = (props: DropzoneClearProps) => {
  const { resetFiles } = useDropzoneContext();
  const { icon, ...rest } = props;
  return (
    <IconButton 
      {...rest} 
      icon={icon || <Icon icon="CloseDelete" style="Outlined"/>}
      onClick={resetFiles} 
    />
  );
};

export default DropzoneClear;
